import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import WrappedApp from "./App";

import "./i18n";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <WrappedApp />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
